.active {
    filter: drop-shadow(0 0 10px #ff0000);
}
